module.exports = __webpack_public_path__ + "static/media/step-7-view-app-in-private-apps.d30ea7a9.png";